import React, { Component, Fragment } from 'react';
import { isEmpty } from "lodash";
import CategoriesForm from './CategoriesForm';
import { EditRounded, ExpandLess, ExpandMore, AddCircle, CloudDownloadRounded, CloudUploadRounded, Visibility, VisibilityOff } from '@mui/icons-material';
import withStyles from '@mui/styles/withStyles';

import { 
    IconButton, 
    Grid, 
    Typography,
    Button,
    ListSubheader,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Collapse,
    Box,
    Alert,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';

import SearchBar from '../../common/SearchBar';
import DeactivateCategoryDialog from '../../common/DeactivateCategoryDialog';
import SpendingBySubCategory from '../../Spendings/SpendingBySubCategory';
import axios from 'axios';

const styles = theme => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  nested2: {
    paddingLeft: theme.spacing(8),
  },
});

const orderByAsc = (list, field) => {
    list.sort( (a, b) => {
        if (a[field] > b[field]) return 1;
        if (b[field] > a[field]) return -1;

        return 0;
    })
    return list
}

class CategoriesList extends Component {
    state = { 
        page: 0,
        rowsPerPage: 10,
        openForm: false,
        openUpdate: false,
        openDetails: false,
        selectedCat: {},
        selectedCategory: {},
        searchValue: "",
        importing: false,
        importError: "",
        openImportPreview: false,
        importPreviewData: [],
        importPreviewHeaders: [],
        importFile: null,
        openDeactivateDialog: false,
        categoryToDeactivate: null,
    }
    fileInputRef = React.createRef();
    
    componentDidMount() {
        window.scrollTo(0, 0);
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ page: 0, rowsPerPage: parseInt(event.target.value) });
    };

    handleClose = () => {
		this.setState({ 
            openForm: false,
            openUpdate: false,
            openDetails: false,
            selectedCat: {},
            selectedCategory: {},
        });
    };

    categoryMatchesSearch = (cat, searchValue) => {
        if (!cat || !searchValue) return false;
        const sv = searchValue.toLowerCase();
        return (cat.category_name?.toLowerCase().includes(sv) ||
                cat.category_accounting_id?.toLowerCase().includes(sv));
    };

    categoryOrDescendantMatchesSearch = (categoryId, searchValue, isParent = false) => {
        const { CATEGORIES } = this.props;
        const cat = isParent ? CATEGORIES.PARENT?.[categoryId] : CATEGORIES.CHILD?.[categoryId];
        if (!cat) return false;
        if (this.categoryMatchesSearch(cat, searchValue)) return true;
        const childIds = CATEGORIES.LIST?.[categoryId] || [];
        return childIds.some(childId => this.categoryOrDescendantMatchesSearch(childId, searchValue, false));
    };

    hasMatchingDescendant = (categoryId, searchValue, isParent = false) => {
        const { CATEGORIES } = this.props;
        const childIds = CATEGORIES.LIST?.[categoryId] || [];
        return childIds.some(childId => this.categoryOrDescendantMatchesSearch(childId, searchValue, false));
    };

    getCategoriesList = () => {
        const { CATEGORIES } = this.props;
        const { searchValue } = this.state;
        if (!isEmpty(CATEGORIES.PARENT)){
            
            let list = orderByAsc(Object.values(CATEGORIES.PARENT), "category_accounting_id")
            if (!isEmpty(searchValue)) {
                list = list.filter(cat => this.categoryOrDescendantMatchesSearch(cat.category_id, searchValue, true));
            }

            return list.map(item => {
                const isActive = item.is_active !== false;
                let shade = item.category_color.slice(1, 2);
                let textColor = isNaN(shade)  ? "" : "white" ;
                return (
                    <Fragment key={item.category_id}>
                        <ListItem 
                            style={{
                                backgroundColor: isActive ? item.category_color : "#e0e0e0",
                                color: isActive ? textColor : "#9e9e9e",
                                opacity: isActive ? 1 : 0.6,
                            }}
                        >
                            <ListItemText 
                                primary={`${item.category_accounting_id} - ${item.category_name}`} 
                                sx={!isActive ? { textDecoration: "line-through" } : {}}
                            />
                            
                            <IconButton
                                style={{color: isActive ? textColor : "#9e9e9e"}}
                                onClick={ () => this.setState({
                                    openUpdate: true,
                                    selectedCat: item
                                }) }
                                size="large">
                                <EditRounded />
                            </IconButton>
                            <IconButton
                                style={{color: isActive ? textColor : "#9e9e9e"}}
                                onClick={ () => isActive ? this.setState({ openDeactivateDialog: true, categoryToDeactivate: item }) : this.handleToggleActive(item) }
                                size="large"
                                title={isActive ? "Désactiver" : "Activer"}>
                                {isActive ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                            {!isEmpty(CATEGORIES.LIST[item.category_id]) &&
                                <IconButton
                                    style={{color: textColor}}
                                    onClick={ () => this.setState({
                                        [item.category_id]: !this.state[item.category_id]
                                    }) }
                                    size="large">
                                {(this.state[item.category_id] || (!isEmpty(searchValue) && this.hasMatchingDescendant(item.category_id, searchValue, true))) ? <ExpandLess /> : <ExpandMore />}

                                </IconButton>

                            }
                        </ListItem>
                        
                        {(this.state[item.category_id] || (!isEmpty(searchValue) && this.hasMatchingDescendant(item.category_id, searchValue, true))) && 
                            this.getSubCategoriesList(item.category_id)
                        }                        
                    </Fragment>
                );
            });
        }
    }
    getSubCategoriesList = (cat, padding = "nested") => {
        const { CHILD, LIST } = this.props.CATEGORIES;
        const { classes } = this.props;
        const { searchValue } = this.state;
        if (!isEmpty(LIST[cat])){
            let childList = LIST[cat].map(childID => CHILD[childID]).filter(Boolean);
            if (!isEmpty(searchValue)) {
                childList = childList.filter(child =>
                    this.categoryOrDescendantMatchesSearch(child.category_id, searchValue, false)
                );
            }
            let list = orderByAsc(Object.values(childList), "category_accounting_id")

            return list.map(child => {
                const isChildActive = child.is_active !== false;
                return (
                <Collapse
                    key={child.category_id}
                    in={true} 
                    timeout="auto" 
                    unmountOnExit
                >
                    <List component="div" disablePadding >
                        <ListItem button className={classes[padding]}
                            style={{
                                opacity: isChildActive ? 1 : 0.6,
                                backgroundColor: isChildActive ? "inherit" : "#f5f5f5",
                            }}
                        >
                            <ListItemText 
                                primary={`${child.category_accounting_id} - ${child.category_name}`}
                                sx={!isChildActive ? { textDecoration: "line-through", color: "#9e9e9e" } : {}}
                            />
                            
                            <IconButton
                                onClick={ () => this.setState({
                                    openUpdate: true,
                                    selectedCat: child
                                }) }
                                size="large">
                                <EditRounded />
                            </IconButton>
                            <IconButton
                                onClick={ () => isChildActive ? this.setState({ openDeactivateDialog: true, categoryToDeactivate: child }) : this.handleToggleActive(child) }
                                size="large"
                                title={isChildActive ? "Désactiver" : "Activer"}>
                                {isChildActive ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                            {!isEmpty(LIST[child.category_id]) && 

                            <IconButton
                                onClick={ () => this.setState({
                                    [child.category_id]: !this.state[child.category_id]
                                }) }
                                size="large">
                            {(this.state[child.category_id] || (!isEmpty(searchValue) && this.hasMatchingDescendant(child.category_id, searchValue, false))) ? <ExpandLess /> : <ExpandMore />}

                            </IconButton>
                            }
                        </ListItem>
                        {(this.state[child.category_id] || (!isEmpty(searchValue) && this.hasMatchingDescendant(child.category_id, searchValue, false))) && 
                            this.getSubCategoriesList(child.category_id, "nested2")
                        }  
                    </List>
                </Collapse>
            )});
        }
    }

    handleToggleActive = async (category) => {
        const newActive = category.is_active === false ? true : false;
        const result = await this.props.toggleCategoryActive({
            category_id: category.category_id,
            is_active: newActive,
        });
        if (result?.success) {
            this.props.notif?.("success", newActive ? "Catégorie activée" : "Catégorie désactivée");
            this.setState({ openDeactivateDialog: false, categoryToDeactivate: null });
        } else if (result?.error) {
            this.props.notif?.("error", result.error);
        }
    }

    handleChange = (e) => {
        const { value } = e.target;

        this.setState({
            "searchValue": value.toLowerCase()
        })
    }

    handleImportClick = () => {
        this.fileInputRef.current?.click();
    }

    parseCSV = (text) => {
        const lines = text.split(/\r?\n/).filter(line => line.trim());
        if (lines.length < 2) return { headers: [], rows: [] };
        const headers = lines[0].split(",").map(h => h.trim());
        const rows = lines.slice(1).map(line => line.split(",").map(c => c.trim()));
        return { headers, rows };
    }

    handleImportFile = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = (ev) => {
            try {
                const { headers, rows } = this.parseCSV(ev.target.result || "");
                if (rows.length === 0) {
                    this.setState({ importError: "Fichier vide ou format invalide" });
                    return;
                }
                const hasValidFormat = rows.every(r => r.length >= 4) && (headers.length >= 4 || rows[0]?.length >= 4);
                if (!hasValidFormat) {
                    this.setState({ importError: "Format CSV invalide. Attendu: Compte,Catégorie,Couleur Catégorie,Sous Compte,Sous Catégorie,Couleur Sous Catégorie" });
                    return;
                }
                this.setState({
                    openImportPreview: true,
                    importPreviewHeaders: headers.length >= 6 ? headers : ["Compte", "Catégorie", "Couleur Catégorie", "Sous Compte", "Sous Catégorie", "Couleur Sous Catégorie"],
                    importPreviewData: rows,
                    importFile: file,
                    importError: "",
                });
            } catch (err) {
                this.setState({ importError: "Erreur de lecture du fichier" });
            }
        };
        reader.readAsText(file, "UTF-8");
        e.target.value = "";
    }

    handleImportCancel = () => {
        this.setState({
            openImportPreview: false,
            importPreviewData: [],
            importPreviewHeaders: [],
            importFile: null,
        });
    }

    handleImportConfirm = async () => {
        const { importFile } = this.state;
        if (!importFile) return;
        this.setState({ importing: true });
        try {
            const formData = new FormData();
            formData.append('myFile', importFile);
            const res = await axios.post('/extract/import/categories', formData);
            console.log("Import response:", res.data);
            const data = res.data;
            if (data.error) {
                this.setState({ importError: data.error });
                this.props.notif?.("error", data.error);
            } else {
                this.props.fetchParentCategories();
                this.props.fetchChildCategories();
                const msg = data.created > 0
                    ? `${data.created} catégorie(s) importée(s)`
                    : "Aucune catégorie importée (doublons ou erreurs)";
                this.props.notif?.("success", msg);
                if (data.errors?.length) {
                    this.setState({ importError: data.errors.join(" ; ") });
                } else {
                    this.setState({ importError: "" });
                }
                this.handleImportCancel();
            }
        } catch (err) {
            const msg = err.response?.data?.error || err.message || "Erreur d'import";
            this.setState({ importError: msg });
            this.props.notif?.("error", msg);
        } finally {
            this.setState({ importing: false });
        }
    }

    render() {
        const { openForm, openUpdate, selectedCat, openDetails, selectedCategory } = this.state;
        const { CATEGORIES, SPENDINGS, LABELS, SUPPLIERS, BANKS, classes } = this.props;

        return (
            <Box>
                {this.state.openDeactivateDialog && this.state.categoryToDeactivate && (
                    <DeactivateCategoryDialog
                        open={true}
                        categoryName={this.state.categoryToDeactivate.category_name}
                        close={() => this.setState({ openDeactivateDialog: false, categoryToDeactivate: null })}
                        onConfirm={() => this.handleToggleActive(this.state.categoryToDeactivate)}
                        disabledSubmit={this.props.STATE?.categories?.fetching}
                    />
                )}
                {openForm &&
                    <CategoriesForm open={openForm} handleClose={this.handleClose} {...this.props} />
                }
                {openUpdate && !isEmpty(selectedCat) &&
                    <CategoriesForm 
                        update 
                        category={selectedCat} 
                        hasChild={!isEmpty(CATEGORIES.LIST[selectedCat.category_id])}
                        open={openUpdate} 
                        handleClose={this.handleClose} 
                        {...this.props} 
                    />
                }
                {openDetails && selectedCategory &&
					<SpendingBySubCategory 
						SPENDINGS={Object.values(SPENDINGS).filter(item => CATEGORIES.CHILD[item.spending_category].category_parent === selectedCategory)} 
						SPENDINGSLIST={SPENDINGS} 
						category={selectedCategory} 
						CATEGORIES={CATEGORIES}
						LABELS={LABELS}
						SUPPLIERS={SUPPLIERS}
						BANKS={BANKS}
						view={"ADMIN"}
						fetchSpendingPayments={this.props.fetchSpendingPayments}
						openFormCustom={this.props.openFormCustom}
						handleClose={
							() => this.setState({ selectedCategory: "", openDetails: false})
						} 
					/>
				}
                
                <Typography variant="h6">
                    Liste des Catégories
                </Typography>

                <Box style={{ display:"flex", justifyContent:"space-between", alignItems: "center"}}>
                    <SearchBar 
                        handleChange={this.handleChange} 
                        label="Catégorie"
                        searchValue={this.state.searchValue}
                    />
                    <Box p={1} style={{ display:"flex", justifyContent:"space-between"}}>
                        <Button 
                            variant="contained" 
                            color="secondary" 
                            onClick={() => this.setState({ openForm: true })} title="Nouvelle Catégorie"
                            startIcon={<AddCircle />}
                        >
                            Ajouter
                        </Button>
                        <IconButton
                            color="primary"
                            onClick={ () => this.props.handleDownload("/extract/categories", "MJB_categories.csv") }
                            disabled={this.props.downloading}
                            size="large"
                            title="Télécharger">
                            <CloudDownloadRounded />
                        </IconButton>
                        <input
                            type="file"
                            ref={this.fileInputRef}
                            accept=".csv"
                            style={{ display: 'none' }}
                            onChange={this.handleImportFile}
                        />
                        <IconButton
                            color="primary"
                            onClick={this.handleImportClick}
                            disabled={this.state.importing}
                            size="large"
                            title="Importer">
                            <CloudUploadRounded />
                        </IconButton>
                    </Box>
                </Box>
                {this.state.importError && (
                    <Alert severity="error" onClose={() => this.setState({ importError: "" })} sx={{ mt: 1 }}>
                        {this.state.importError}
                    </Alert>
                )}
                <Dialog
                    open={this.state.openImportPreview}
                    onClose={this.handleImportCancel}
                    maxWidth="md"
                    fullWidth
                >
                    <DialogTitle>Prévisualisation - Import des catégories</DialogTitle>
                    <DialogContent>
                        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
                            {this.state.importPreviewData.length} ligne(s) à importer
                        </Typography>
                        <TableContainer sx={{ maxHeight: 400 }}>
                            <Table size="small" stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        {this.state.importPreviewHeaders.map((h, i) => (
                                            <TableCell key={i} sx={{ fontWeight: 600, backgroundColor: "grey.100" }}>
                                                {h}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.importPreviewData.map((row, i) => (
                                        <TableRow key={i}>
                                            {this.state.importPreviewHeaders.map((h, j) => {
                                                const cell = row[j] || "";
                                                const isColorCol = h && (h.toLowerCase().includes("couleur") || j === 2 || j === 5);
                                                const isValidHex = cell && /^#[0-9A-Fa-f]{3,8}$/.test(cell.trim());
                                                const bgColor = isColorCol && isValidHex ? cell.trim() : null;
                                                const hex = bgColor?.slice(1) || "";
                                                const r = hex.length === 3 ? parseInt(hex[0] + hex[0], 16) : parseInt(hex.slice(0, 2), 16);
                                                const g = hex.length === 3 ? parseInt(hex[1] + hex[1], 16) : parseInt(hex.slice(2, 4), 16);
                                                const b = hex.length === 3 ? parseInt(hex[2] + hex[2], 16) : parseInt(hex.slice(4, 6) || "00", 16);
                                                const luminance = (isNaN(r) ? 0 : r) + (isNaN(g) ? 0 : g) + (isNaN(b) ? 0 : b);
                                                const isDark = bgColor ? luminance / 3 < 128 : false;
                                                return (
                                                    <TableCell
                                                        key={j}
                                                        sx={
                                                            bgColor
                                                                ? { backgroundColor: bgColor, color: isDark ? "#fff" : "#333", minWidth: 80 }
                                                                : {}
                                                        }
                                                    >
                                                        {cell}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </DialogContent>
                    <DialogActions sx={{ px: 3, pb: 2 }}>
                        <Button onClick={this.handleImportCancel} color="inherit">
                            Annuler
                        </Button>
                        <Button
                            onClick={this.handleImportConfirm}
                            variant="contained"
                            color="primary"
                            disabled={this.state.importing}
                        >
                            {this.state.importing ? "Import en cours..." : "Valider"}
                        </Button>
                    </DialogActions>
                </Dialog>
                <br/>
                <br/>

                <List
                    style={{maxWidth: "inherit"}}
                    component="div"
                    aria-labelledby="nested-list-subheader"
                    subheader={
                        <ListSubheader component="div" id="nested-list-subheader">
                            Nom
                        </ListSubheader>
                    }
                    className={classes.root}
                >
                {this.getCategoriesList()}
                </List>
                
            </Box>
        );
    }
}

export default withStyles(styles)(CategoriesList);